import MobileDetect from 'mobile-detect';
import Vue from 'vue';
import Vuex from 'vuex';
import {AxiosInstance} from 'axios';
import Environment from '@flashpointbv/solar-ui-environment';
import {HttpClientFactory} from '@flashpointbv/solar-ui-http-client';

declare module 'vue/types/vue' {
  interface Vue {
    $mobileDetect: MobileDetect,
    $solarClient: AxiosInstance,
    $eventBus: Vue,
    $solarCdnBaseUrl: string,
    $baseUrl: string,
  }
}

declare module 'vuex/types' {
  interface Store<S> {
    $mageClient: AxiosInstance,
    $solarClient: AxiosInstance,
    $solarCdnBaseUrl: string,
    $baseUrl: string,
    $dataImportApiBaseUrl: string,
    $dataImportImageBaseUrl: string,
  }
}

/**
 * Price format prototype
 */
Number.prototype['priceFormat'] = function(): string {
  return this.toFixed(2).replace('.', ',').replace(",00",",-")
};

/**
 * Price format prototype
 */
String.prototype['priceFormat'] = function(): string {
  return parseFloat(this).toFixed(2).replace('.', ',').replace(",00",",-")
};

/**
 * stripslashes prototype
 */
String.prototype['stripslashes'] = function(): string {
  return this.replace(/\\(.)/mg, "$1");
};

const solarClient = HttpClientFactory.makeInstance({
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]')['content'] || '',
      'X-STORE-ID': Environment().get('active_store_id')
    },
  },
  withCredentials: true
});

// AVP-409: listing JSON was reused from the browser HTTP cache on page change.
solarClient.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase();
  const url = String(config.url || '');

  if (method === 'get' && url.includes('/product/list')) {
    config.params = Object.assign({}, config.params || {}, {nocache: 1});
  }

  return config;
});

/**
 * Check for mobile devices prototype
 */
Vue.prototype.$mobileDetect = new MobileDetect(window.navigator.userAgent);
Vue.prototype.$solarClient = solarClient;

Vuex.Store.prototype['$solarClient'] = solarClient;
